import { Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { formatNumber } from "../../../../../../infrastructure/utils/formatters";
import { ManagementWidgetShell } from "../managementDashboardWidgets";
import { buildDrillDownHref, pick } from "../managementDashboardUtils";

const ContractorPerformanceTable = ({ loading, error, data, onRetry }) => {
  const contractors = data?.contractors || data?.Contractors || [];

  return (
    <ManagementWidgetShell
      title="رتبه‌بندی پیمانکاران"
      subheader="عملکرد بر اساس درخواست‌های تخصیص‌یافته"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      {!contractors.length && !loading && !error ? (
        <Typography color="text.secondary">پیمانکار فعالی با تخصیص پرونده یافت نشد.</Typography>
      ) : (
        <TableContainer sx={{ overflowX: "auto" }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>پیمانکار</TableCell>
                <TableCell align="right">درخواست</TableCell>
                <TableCell align="right">ظرفیت (kW)</TableCell>
                <TableCell align="right">قرارداد</TableCell>
                <TableCell align="right">اجرا</TableCell>
                <TableCell align="right">بهره‌برداری</TableCell>
                <TableCell align="right">تبدیل</TableCell>
                <TableCell align="right">تأخیر میانگین</TableCell>
                <TableCell align="right">SLA</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {contractors.map((row) => {
                const id = pick(row, "contractorInfoId", "ContractorInfoId");
                const href = buildDrillDownHref(pick(row, "drillDown", "DrillDown"));
                return (
                  <TableRow key={id} hover>
                    <TableCell>
                      {href ? (
                        <Link component={RouterLink} to={href} underline="hover">
                          {pick(row, "contractorTitle", "ContractorTitle")}
                        </Link>
                      ) : (
                        pick(row, "contractorTitle", "ContractorTitle")
                      )}
                    </TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "requestCount", "RequestCount"))}</TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "totalCapacityKw", "TotalCapacityKw"))}</TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "contractCount", "ContractCount"))}</TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "executedCount", "ExecutedCount"))}</TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "commissionedCount", "CommissionedCount"))}</TableCell>
                    <TableCell align="right">
                      {pick(row, "conversionRate", "ConversionRate") != null
                        ? `${formatNumber(pick(row, "conversionRate", "ConversionRate"), 1)}٪`
                        : "—"}
                    </TableCell>
                    <TableCell align="right">
                      {pick(row, "averageDelayDays", "AverageDelayDays") != null
                        ? formatNumber(pick(row, "averageDelayDays", "AverageDelayDays"), 1)
                        : "—"}
                    </TableCell>
                    <TableCell align="right">
                      {pick(row, "slaScore", "SlaScore") != null
                        ? formatNumber(pick(row, "slaScore", "SlaScore"), 1)
                        : "—"}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </ManagementWidgetShell>
  );
};

export default ContractorPerformanceTable;
